// // main.jsx
// import React from 'react';
// import { createRoot } from 'react-dom/client';
// import App from './App';
// import { BrowserRouter } from 'react-router-dom';
// import { Provider } from 'react-redux';
// import store from './store/store';

// const container = document.getElementById('root');
// const root = createRoot(container);

// root.render(
//   <React.StrictMode>
//     <Provider store={store}>
//       <BrowserRouter>
//         <App />
//       </BrowserRouter>
//     </Provider>
//   </React.StrictMode>
// );
// import React, { useState } from 'react';
// import React, { useState, StrictMode } from 'react';
// import { createRoot } from 'react-dom/client';
// import App from './App';
// import { BrowserRouter } from 'react-router-dom';
// import { Provider } from 'react-redux';
// import store from './store/store';

// import { ThemeContext } from './context/ThemeContext.jsx';

// const container = document.getElementById('root');
// const root = createRoot(container);

// const RootComponent = () => {
//   const [background, setBackground] = useState("light"); // or whatever default you want
//   console.log("RootComponent rendered with background:", background);

//   return (
//     <React.StrictMode>
//       <Provider store={store}>
//         <ThemeContext.Provider value={{ background, changeBackground: setBackground }}>
//           <BrowserRouter>
//             <App />
//           </BrowserRouter>
//         </ThemeContext.Provider>
//       </Provider>
//     </React.StrictMode>
//   );
// };

// root.render(
//   <RootComponent />
// );

import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.jsx'
import { BrowserRouter } from 'react-router-dom';
import {Provider} from 'react-redux';
// import {store} from './store/store';
import store from './store/store';
import  ThemeContext  from "./context/ThemeContext"; 

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <Provider store = {store}>
      <BrowserRouter>
        <ThemeContext>
          <App />
        </ThemeContext>
      </BrowserRouter>
    </Provider>
  </StrictMode>,
)
